import { simpleLookupConfig } from "../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../lookupManagement";

export const vsObjectName = "contractRenewalType";

const url = "/api/contract/ContractRenewalType";

export const contractRenewalTypeLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Renewal Type",
    url,
    defaultSort: "Name",
  }
);
